<template>
  <v-col cols="12" sm="6" lg="4">
    <div class="pb-1 text-label-medium font-weight-bold">{{ label }}</div>
    <div class="text-body-large">
      <slot />
    </div>
  </v-col>
</template>

<script setup>
defineProps({ label: String, value: String })
</script>

<style lang="css" scoped></style>
